(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.edLookInitialized) return;
    window.edLookInitialized = true;

    function setOpen(button, open) {
      button.setAttribute('aria-expanded', String(open));
      var card = document.getElementById(button.getAttribute('aria-controls'));
      if (card) card.hidden = !open;
    }

    function closeAll(except) {
      document.querySelectorAll('.ed-look__dot[aria-expanded="true"]').forEach(function (button) {
        if (button !== except) setOpen(button, false);
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.ed-look__dot');
      if (button) {
        var isOpen = button.getAttribute('aria-expanded') === 'true';
        closeAll(button);
        setOpen(button, !isOpen);
        return;
      }
      if (!event.target.closest('.ed-look__card')) closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.hsInitialized) return;
      root.hsInitialized = true;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
      if (slides.length < 2) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-dot]'));
      var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var paused = false;

      function preload(i) {
        var slide = slides[(i + slides.length) % slides.length];
        slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }

      function stop() {
        clearTimeout(timer);
        timer = null;
      }

      function restart() {
        stop();
        if (delay > 0 && !reduceMotion && !paused && !document.hidden) {
          timer = setTimeout(function () {
            go(index + 1);
          }, delay);
        }
      }

      function go(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (slide, n) {
          var active = n === index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
          slide.querySelectorAll('a').forEach(function (a) {
            if (active) {
              a.removeAttribute('tabindex');
            } else {
              a.setAttribute('tabindex', '-1');
            }
          });
        });
        dots.forEach(function (dot, n) {
          dot.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
        preload(index + 1);
        restart();
      }

      var prev = root.querySelector('[data-hs-prev]');
      var next = root.querySelector('[data-hs-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { go(n); });
      });

      root.addEventListener('mouseenter', function () { paused = true; stop(); });
      root.addEventListener('mouseleave', function () { paused = false; restart(); });
      root.addEventListener('focusin', function () { paused = true; stop(); });
      root.addEventListener('focusout', function () { paused = false; restart(); });

      var startX = null;
      root.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else restart();
      });

      // テーマ編集でスライドを選んだら、そのスライドを表示して止める
      root.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target.closest('[data-hs-slide]'));
        if (i > -1) {
          paused = true;
          go(i);
          stop();
        }
      });
      root.addEventListener('shopify:block:deselect', function () {
        paused = false;
        restart();
      });

      go(0);
    }

    function initAll() {
      document.querySelectorAll('[data-hs]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.ssInitialized) return;
      root.ssInitialized = true;

      var list = root.querySelector('[data-ss-list]');
      var bar = root.querySelector('[data-ss-progress]');
      if (!list || !bar) return;

      var thumb = bar.querySelector('[data-ss-thumb]');
      var current = bar.querySelector('[data-ss-current]');
      var ticking = false;

      function update() {
        ticking = false;
        var max = list.scrollWidth - list.clientWidth;
        if (max <= 1) {
          bar.hidden = true;
          return;
        }
        bar.hidden = false;

        var ratio = Math.min(Math.max(list.scrollLeft / max, 0), 1);
        var trackWidth = thumb.parentElement.clientWidth;
        var thumbWidth = Math.max((list.clientWidth / list.scrollWidth) * trackWidth, 24);
        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + (trackWidth - thumbWidth) * ratio + 'px)';

        var cards = list.children;
        var padding = parseFloat(getComputedStyle(list).paddingLeft) || 0;
        var index = 1;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].offsetLeft - padding <= list.scrollLeft + 10) index = i + 1;
        }
        if (ratio > 0.98) index = cards.length;
        current.textContent = index;
      }

      function requestUpdate() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      list.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-ss]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
